import { useEffect, useRef } from 'preact/hooks';

export function EquipmentGlimmer({src, level, alt, className}: {src:string;level:number;alt:string;className?:string}) {
 const ref=useRef<HTMLCanvasElement>(null);
 useEffect(()=>{
  let frame=0,cancelled=false,visible=true,last=0;
  const canvas=ref.current!, image=new Image();
  const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;});observer.observe(canvas);
  image.onload=()=>{
   if(cancelled)return;canvas.width=image.naturalWidth;canvas.height=image.naturalHeight;
   const ctx=canvas.getContext('2d')!;ctx.imageSmoothingEnabled=false;
   const color=level>=20?'#ff5757':level>=10?'#ffcd59':'#5cff91';
   const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
   ctx.drawImage(image,0,0);const pixels=ctx.getImageData(0,0,canvas.width,canvas.height).data,anchors:{x:number;y:number}[]=[];
   for(let y=0;y<canvas.height;y++)for(let x=0;x<canvas.width;x++){const p=(y*canvas.width+x)*4;if(pixels[p+3]>180&&pixels[p]+pixels[p+1]+pixels[p+2]>300)anchors.push({x,y});}
   const stars=[.2,.5,.8].map(n=>anchors[Math.floor(anchors.length*n)]).filter(Boolean);
   const draw=(time:number)=>{
    if(cancelled)return;
    if(visible&&!document.hidden&&time-last>=45){
     last=time;ctx.clearRect(0,0,canvas.width,canvas.height);ctx.globalCompositeOperation='source-over';ctx.drawImage(image,0,0);
     ctx.globalCompositeOperation='source-atop';ctx.globalAlpha=reduced?.055:.055+.015*Math.sin(time/700);ctx.fillStyle=color;ctx.fillRect(0,0,canvas.width,canvas.height);ctx.globalAlpha=1;
     const center=reduced?canvas.width/2:((time/66)%(canvas.width+40))-20;
     const shine=ctx.createLinearGradient(center-7,0,center+7,13);
     shine.addColorStop(0,'rgba(255,255,255,0)');shine.addColorStop(.42,color+'30');shine.addColorStop(.5,'rgba(255,255,255,.52)');shine.addColorStop(.58,color+'30');shine.addColorStop(1,'rgba(255,255,255,0)');
     ctx.fillStyle=shine;ctx.fillRect(0,0,canvas.width,canvas.height);
     stars.forEach((s,i)=>{ctx.globalAlpha=reduced?.25:Math.pow(Math.max(0,Math.sin(time/470+i*2.15)),7)*.8;ctx.fillStyle='white';ctx.fillRect(s.x-1,s.y,3,1);ctx.fillRect(s.x,s.y-1,1,3);});
     ctx.globalAlpha=1;ctx.globalCompositeOperation='source-over';canvas.dataset.glimmerReady='true';
    }
    if(!reduced)frame=requestAnimationFrame(draw);
   };draw(performance.now()+50);
  };
  image.src=src;
  return()=>{cancelled=true;cancelAnimationFrame(frame);observer.disconnect();image.onload=null;};
 },[src,level]);
 return <canvas ref={ref} role='img' aria-label={alt} data-glimmer-level={level} class={className} style={{imageRendering:'pixelated'}}/>;
}
